<template>
    <div>
        <div v-if="!isInitialized">Loading event selector</div>
        <div class="row" v-if="isInitialized">
            <div class="col">
                <div v-if="showPastEventsFilter">
                    <input type="checkbox" id="show-past-events" v-model="query.showPastEvents">
                    <label for="show-past-events">Show past events</label>
                </div>
                <input type="checkbox" id="show-available-only" v-model="query.availableOnly">
                <label for="show-available-only">Show available events only</label>
            </div>
        </div>
        <div class="resource-selector row" v-if="isInitialized">
            <div class="col">
                <input type="hidden" :name="formFieldName" :value="selectedFormValue || prefilledEventId">
                <multiselect :options="options"
                             @search-change="asyncQuery"
                             @select="select"
                             :internal-search="false"
                             v-model="selectedEvent"
                             :placeholder="placeholder"
                             :loading="isLoading"
                             :preserve-search="true">
                    <template slot="singleLabel" slot-scope="{ option }">
                        <div class="row">
                            <div class="col">
                                <strong>
                                    <span class="option__title">{{ option.name }}
                                    </span>
                                </strong><span>({{ option.start_date }})</span>
                            </div>
                        </div>
                        <div class="row">
                            <span class="col">{{ option.venue.name }}, {{
                                    option.venue.city
                                }}, {{ option.venue.country_code }}</span>
                        </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                        <div class="row">
                            <div class="col">
                                <strong>
                                    <span class="option__title">{{ option.name }}
                                    </span>
                                </strong><span>({{ option.start_date }})</span>
                            </div>
                        </div>
                        <div class="row">
                            <span class="col">{{ option.venue.name }}, {{
                                    option.venue.city
                                }}, {{ option.venue.country_code }}</span>
                        </div>
                    </template>
                    <template slot="noResult">
                        No results found
                    </template>
                    <template slot="noOptions">
                        Start searching by typing
                    </template>
                    <pre class="language-json"><code>{{ selectedEvent }}</code></pre>
                </multiselect>
                <div v-if="couldNotFindPreselectedEvent" class="text text-danger">The prefilled event with id
                    ({{ prefilledEventId }}) was not found.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _ from "lodash";
import axios from "axios";
import qs from "qs";

export default {
    components: {Multiselect},
    name: "EventSearch",

    props: {
        placeholder: {
            default: 'Add by searching...'
        },
        formFieldName: {
            default: 'event_id'
        },
        prefilledEventId: {
            default: null
        },
        showPastEventsFilter: {
            default: true
        }
    },

    mounted() {
        if (this.prefilledEventId !== null && this.prefilledEventId !== '') {
            this.fetchAndSelectSingleEvent(this.prefilledEventId).finally(() => {
                this.isInitialized = true;
            })
        } else {
            this.isInitialized = true;
        }
    },

    data: () => {
        return {
            query: {
                availableOnly: true,
                showPastEvents: false
            },
            options: [],
            selectedEvent: null,
            isLoading: false,
            isInitialized: false,
        };
    },

    computed: {
        selectedFormValue() {
            return this.selectedEvent?.id;
        },

        couldNotFindPreselectedEvent() {
            return !this.isLoading && this.prefilledEventId !== null && this.prefilledEventId !== '' && this.selectedEvent === null;
        }
    },

    methods: {

        asyncQuery(queryString) {
            if (!queryString) {
                this.options = [];
                return;
            }

            this.isLoading = true;
            this.fetchEvents(queryString);
        },

        fetchEvents: _.debounce(function (queryString) {
            const stringifiedQueryString = qs.stringify({
                filters: {
                    query: queryString,
                    available: this.query.availableOnly,
                    showPastEvents: this.query.showPastEvents
                }
            });

            axios.get(`/admin/api/events?${stringifiedQueryString}`)
                    .then((resp) => {
                        this.isLoading = false;
                        this.options = resp.data.data;
                    })
                    .catch(() => {
                        this.isLoading = false
                    });
        }, 500),

        fetchAndSelectSingleEvent(id) {
            return axios.get(`/admin/api/events/${id}`)
                    .then(resp => {
                        this.select(resp.data.data);
                    })
        },

        select: function (resource) {
            this.selectedEvent = resource;
            this.$emit('event-selected', this.selectedEvent.uuid, this.selectedEvent.traveller_data_required, this.selectedEvent.restrictions);
        },

        remove() {
            this.selectedEvent = null;
        }
    }
}
</script>

<style scoped>
</style>
